import { getLanguage, Language } from "@/utils/languageUtils";
import sv from "../locales/sv/exterior360.json";
import en from "../locales/en/exterior360.json";
import { VIEW_STEP_TYPES, type ViewType360 } from "@/types/exterior360";

export const exterior360Labels = (lang?: Language) => {
  const language = lang ?? getLanguage();
  return language === "en" ? en : sv;
};

/** Returns VIEW_STEPS with i18n labels based on current/specified language */
export const getViewStepsWithLabels = (
  lang?: Language
): { viewType: ViewType360; label: string }[] => {
  const labels = exterior360Labels(lang);
  return VIEW_STEP_TYPES.map(({ viewType }) => ({
    viewType,
    label:
      viewType === "front"
        ? (labels as { viewFront?: string }).viewFront ?? "Front"
        : (labels as { viewSide?: string }).viewSide ?? "Side",
  }));
};
